const profile = {
    name: 'Name',
    avatar: 'Avatar',
    givenName: 'Vorname',
    familyName: 'Nachname',
    middleName: 'Zweitname',
    fullname: 'Vollständiger Name',
    nickname: 'Spitzname',
    preferredUsername: 'Bevorzugter Benutzername',
    profile: 'Profil',
    website: 'Webseite',
    gender: 'Geschlecht',
    birthdate: 'Geburtsdatum',
    zoneinfo: 'Zeitzone',
    locale: 'Sprache',
    address: {
        formatted: 'Adresse',
        streetAddress: 'Straßenadresse',
        locality: 'Stadt',
        region: 'Bundesland/Provinz',
        postalCode: 'Postleitzahl',
        country: 'Land',
    },
    gender_options: {
        female: 'Weiblich',
        male: 'Männlich',
        prefer_not_to_say: 'Keine Angabe',
    },
    checkbox_value: {
        checked: 'Ja',
        unchecked: 'Nein',
    },
};
export default Object.freeze(profile);
